import { render } from "./odn-no-content.vue?vue&type=template&id=125e6b08"
import script from "./odn-no-content.vue?vue&type=script&lang=js"
export * from "./odn-no-content.vue?vue&type=script&lang=js"

import "./odn-no-content.vue?vue&type=style&index=0&id=125e6b08&lang=scss"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__